import 'react-alice-carousel/lib/alice-carousel.css'

import AliceCarousel from 'react-alice-carousel'
import Img from 'gatsby-image'
import React from 'react'
import styles from './slider.module.css'

const Slider = (props) => {
  return (
    <section>
      <AliceCarousel
        autoWidth
        autoPlay
        autoPlayInterval="3000"
        animationDuration="1000"
        infinite
        autoHeight
        disableButtonsControls
        disableDotsControls
        disableSlideInfo
      >
        <div className={styles.slide}>
          <Img
            title="ofertas sherry week"
            fluid={props.slides[0]}
            alt="ofertas sherry week"
          />
        </div>
        <div className={styles.slide}>
          <Img
            title="ofertas sherry week"
            fluid={props.slides[1]}
            alt="ofertas sherry week"
          />
        </div>
      </AliceCarousel>
    </section>
  )
}

export default Slider
